// extracted by mini-css-extract-plugin
module.exports = {"border":"cart_border___wtYP","container":"cart_container__GMftB"};